module.exports = __webpack_public_path__ + "common/icon-arrow-bedb9865df4c2a366b8b8ab195076fa5.svg";